export const fullSpec = {
  defCodes: ['id', 'str0', 'str1', 'num0', 'fwVersion', 'createdAt'],
  defaultSortable: false,
  columns: [
    {
      code: 'id',
      t: 'ID|',
      d: 'id',
      selectable: true,
      w: 100,
      color: '#cccccc',
      sortable: true
    },

    {
      code: 'clientId',
      t: 'Módulo|',
      d: 'clientId',
      selectable: false,
      w: 50
    },

    // {
    //   code: 'code',
    //   t: '|Placa',
    //   d: 'code',
    //   selectable: false
    // },
    // {
    //   code: 'orgCode',
    //   t: '|Organização',
    //   d: 'org.name',
    //   selectable: false,
    //   w: 100
    // },

    {
      code: 'timestamp',
      t: 'Data/hora|',
      d: 'timestamp',
      selectable: false,
      w: 200,
      dataType: 'date',
      format: 'YYYY-MMM-DD HH:mm:ss',
      sortable: true
    },

    {
      code: 'type',
      t: '|Tipo',
      d: 'type',
      selectable: false,
      cellClass: 'mono'
    },
    {
      code: 'str0',
      t: '|str0',
      d: 'str0',
      selectable: true,
      cellClass: 'mono'
    },
    {
      code: 'str1',
      t: '|str1',
      d: 'str1',
      selectable: true,
      cellClass: 'mono'
    },
    {
      code: 'num0',
      t: 'num0|',
      d: 'num0',
      selectable: true
    },
    {
      code: 'fwVersion',
      t: 'FW|',
      d: 'fwVersion',
      selectable: true,
      f: (x) => `0x${(x || 0).toString(16)}`
    },
    {
      code: 'createdAt',
      t: 'Criado em|',
      d: 'createdAt',
      w: 200,
      selectable: true,
      sortable: true,
      dataType: 'date',
      format: 'YYYY-MMM-DD HH:mm:ss'
    }
  ]
}
